import { BrowserRouter, Routes, Route } from "react-router-dom";
// import { lazy, Suspense } from "react";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { HelmetProvider } from "react-helmet-async";

// styles

// utility
import ScrollToTop from "./utils/ScrollToTop";

// pages
import Home from "./pages/Home";
import About from "./pages/About";
import Schedule from "./pages/Schedule";
import Presenters from "./pages/Presenters";
import Profile from "./pages/Profile";
import HowToListen from "./pages/HowToListen";
import ListenAgain from "./pages/ListenAgain";
import Advertise from "./pages/Advertise";
import Competition from "./pages/Competition";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import Show from "./pages/Show";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";

// components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Player from "./components/Player";

// const Schedule = lazy(() => import("./pages/Schedule")) - TechBase Code Splitting

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop>
          <div className="mx-auto bg-gray-100">
            <Navbar />
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route exact path="/about" element={<About />} />
              <Route exact path="/schedule" element={<Schedule />} />
              <Route exact path="/schedule/:id" element={<Show />} />
              <Route exact path="/presenters" element={<Presenters />} />
              <Route exact path="/presenters/:id" element={<Profile />} />
              <Route exact path="/how-to-listen" element={<HowToListen />} />
              <Route exact path="/listen-again" element={<ListenAgain />} />
              <Route exact path="/advertise" element={<Advertise />} />
              <Route exact path="/competition" element={<Competition />} />
              <Route exact path="/contact" element={<Contact />} />
              <Route exact path="/blog" element={<Blog />} />
              <Route exact path="/blog/:slug" element={<BlogPost />} />
              <Route exact path="/*" element={<NotFound />} />
            </Routes>
            <Footer />
            <Player />
            {/* <Analytics /> */}
            {/* <SpeedInsights /> */}
          </div>
        </ScrollToTop>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
